export default __webpack_public_path__ + "static/media/reviews.7c27a5a9.jpg";